import { createFileRoute, useParams } from '@tanstack/react-router';

import { CourseContentView, type ContentSearch } from '@/views/courses/detail/course-content-view.tsx';
import { useCourse } from '@/views/courses/detail/course-data.ts';
import { EmptyState } from '@/components/ui.tsx';

// 激活条目存在于 URL search string 中，使深链接和刷新能恢复。
export const Route = createFileRoute('/_learner/courses_/$id/content')({
  validateSearch: (search: Record<string, unknown>): ContentSearch => ({
    topic: typeof search.topic === 'string' ? search.topic : undefined,
    quiz: typeof search.quiz === 'string' ? search.quiz : undefined,
    hw: typeof search.hw === 'string' ? search.hw : undefined,
  }),
  component: ContentTab,
});

function ContentTab() {
  const { id } = useParams({ from: '/_learner/courses_/$id/content' });
  const search = Route.useSearch();
  // 复用布局已填充的缓存条目（相同查询 key）。
  const { data: course, isPending, isError } = useCourse(id);

  if (isPending) return <ContentSkeleton />;
  if (isError || !course) return <EmptyState>Could not load course content.</EmptyState>;
  return <CourseContentView course={course} search={search} />;
}

function ContentSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-8 md:grid-cols-[280px_1fr]" aria-hidden>
      <div className="space-y-2">
        {[0, 1, 2, 3, 4].map((i) => (
          <div key={i} className="h-6 w-full animate-pulse rounded bg-neutral-100" />
        ))}
      </div>
      <div className="space-y-3">
        <div className="h-7 w-1/2 animate-pulse rounded bg-neutral-100" />
        <div className="h-4 w-full animate-pulse rounded bg-neutral-100" />
        <div className="h-4 w-5/6 animate-pulse rounded bg-neutral-100" />
      </div>
    </div>
  );
}
